import { SVGProps, Ref, forwardRef } from 'react';

export const SendAndroidOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.928 30.126c-1.265-1.305-.378-4.038 1.396-9.504l.631-1.946c.43-1.324.645-1.987.645-2.676s-.215-1.352-.645-2.676l-.631-1.946C1.55 5.912.664 3.18 1.928 1.874c1.266-1.305 3.659-.126 8.444 2.234l13.362 6.588c4.622 2.278 6.933 3.418 6.933 5.304s-2.311 3.025-6.933 5.304l-13.362 6.588c-4.785 2.36-7.178 3.54-8.444 2.234m20.745-17.278L9.31 6.261C6.839 5.04 5.244 4.263 4.109 3.906a6 6 0 0 0-.372-.106c.01.19.04.458.109.826.25 1.338.851 3.209 1.76 6.011l.774 2.381L19.496 16 6.38 18.98l-.773 2.382c-.91 2.803-1.511 4.673-1.761 6.012a7 7 0 0 0-.109.826q.154-.038.372-.106c1.135-.358 2.73-1.136 5.202-2.355l13.362-6.587c2.386-1.177 3.918-1.94 4.888-2.616.363-.253.552-.429.648-.536-.096-.107-.285-.283-.648-.536-.97-.676-2.502-1.44-4.889-2.616"
                fill="currentColor"
            />
        </g>
    </svg>
));
SendAndroidOutlinedSize32Glyph.displayName = 'SendAndroidOutlinedSize32Glyph';
